import { useMemo } from 'react';

import { AnalyticsReportEmployeeScope } from '~/data/reports';
import { AnalyticsReportConfig } from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/data';
import { useReportEmployeeScopeSelectorOptions } from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/ReportEmployeeScopeSelector/useReportEmployeeScopeSelectorOptions';

type PropsType = {
  employeeScope?: AnalyticsReportEmployeeScope;
  reportConfig: AnalyticsReportConfig;
};

export const useReportEmployeeScopeSelector = (props: PropsType) => {
  const { reportConfig, employeeScope } = props;

  const { employeeScopeOptions, getEmployeeScopeOption } =
    useReportEmployeeScopeSelectorOptions();

  const { selectOptions } = useMemo(() => {
    const validOptions = employeeScopeOptions.filter((option) =>
      reportConfig.options.employeeScopes.includes(option.value),
    );

    if (
      typeof employeeScope === 'undefined' ||
      validOptions.some((o) => o.value === employeeScope)
    ) {
      return {
        selectOptions: validOptions,
      };
    }

    const foundOption = getEmployeeScopeOption(employeeScope);

    return {
      selectOptions: !!foundOption
        ? [foundOption, ...validOptions]
        : validOptions,
    };
  }, [
    getEmployeeScopeOption,
    employeeScopeOptions,
    reportConfig.options.employeeScopes,
    employeeScope,
  ]);

  return {
    selectOptions,
  };
};
